import React from 'react'
import { FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaPhone, FaPinterestP, FaSearch } from 'react-icons/fa'
import { useLanguage } from '../contexts/LanguageContext'
import './Footer.css'

const Footer = () => {
  const { t } = useLanguage()

  return (
    <div className="footer-wrap">
      <div className="container">
        <footer className="footer glass-card">
          <div className="footer-benefits">
            <div><strong>{t('footerSecurePaymentTitle')}</strong><span>{t('footerSecurePaymentText')}</span></div>
            <div><strong>{t('footerDeliveryTitle')}</strong><span>{t('footerDeliveryText')}</span></div>
            <div><strong>{t('footerWarrantyTitle')}</strong><span>{t('footerWarrantyText')}</span></div>
            <div><strong>{t('footerSupportTitle')}</strong><span>{t('footerSupportText')}</span></div>
          </div>

          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <span>SOLAR</span><strong>LIGHT</strong>
              </div>
              <p>
                {t('footerBrandText')}
              </p>

              <div className="footer-socials" aria-label={t('socialNetworks')}>
                <a href="/contact" aria-label="Facebook"><FaFacebookF /></a>
                <a href="/contact" aria-label="Instagram"><FaInstagram /></a>
                <a href="/contact" aria-label="LinkedIn"><FaLinkedinIn /></a>
                <a href="/contact" aria-label="Pinterest"><FaPinterestP /></a>
              </div>

              <form className="footer-newsletter">
                <input type="email" placeholder={t('newsletterPlaceholder')} />
                <button type="button" aria-label={t('subscribe')}>
                  <FaSearch />
                </button>
              </form>
            </div>

            <div className="footer-section" id="about">
              <h4>{t('navigation')}</h4>
              <a href="/">{t('navHome')}</a>
              <a href="/boutique">{t('navProducts')}</a>
              <a href="/collections">{t('navCollections')}</a>
              <a href="/a-propos">{t('navAbout')}</a>
              <a href="/contact">{t('navContact')}</a>
            </div>

            <div className="footer-section" id="contact">
              <h4>Contact</h4>
              <p><FaEnvelope /> contact@solarlight.ma</p>
              <p><FaPhone /> +212 6 82 34 56 78</p>
              <p><FaMapMarkerAlt /> Taza, Morocco</p>
            </div>

            <div className="footer-section">
              <h4>Newsletter</h4>
              <p>{t('footerNewsletterText')}</p>
              <a href="/boutique">{t('viewShop')}</a>
              <p><FaInstagram /> @solarlight</p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>{t('rights')}</p>
            <p>{t('paymentText')}</p>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Footer
